export default __webpack_public_path__ + "static/media/mg.89b4ee39.svg";